import { FRAUD_TYPE_EDIT } from '../../../../../../routes/paths';
import { MouseEventHandler } from 'react';

export const useFraudTypeListActions = (id: string) => {
    const handleEdit: MouseEventHandler<HTMLButtonElement> | undefined = (
        e
    ) => {
        e.stopPropagation();
        window.open(`${FRAUD_TYPE_EDIT}/${id}`, '_blank');
    };

    return {
        handleEdit,
    };
};
